import { gql } from "graphql-tag";

/**
 * Return one row per *product* entry + siteId
 * Keep it tiny – we only need id + user-friendly title for the dropdown.
 */
const QUERY_MANUAL_LIST_ALL_SITES = gql`
  query ManualList {
    products: entries(
      section: ["manuals", "manualsComposableEntries", "quickStartGuides"]
      type: ["product"]
      siteId: ["not", "-1"]
      status: ["enabled", "disabled"]
    ) {
      id
      title
      siteId
      siteHandle
      language
      enabled
      ... on product_Entry {
        userTitle
      }
    }
  }
`;
export default QUERY_MANUAL_LIST_ALL_SITES;
